import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'textSlice'
})
export class TextSlicePipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    return value.length <= 26 ? value : value.slice(0, 26) + '...';
  }

}
